import type { IconConfig } from '#types/config/components/icon'

export default {
  circleRadius: 3,
  paths: [
    ['M8.5 8.5 L7 7', 'M2.5 7.5 L7.5 2.5'],
    ['M8.5 8.5 L7 7', 'M2.5 2.5 L7.5 7.5']
  ]
} satisfies IconConfig['search']
